import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';

export interface AlterarFormaPagamentoDialogData {
  quantidadeContas: number;
  formasPagamento: { idFormaPagamento: number; descricao: string }[];
}

export interface AlterarFormaPagamentoDialogResult {
  confirm: boolean;
  idFormaPagamento: number | null;
}

@Component({
  selector: 'app-alterar-forma-pagamento-dialog',
  standalone: true,
  imports: [
    FormsModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatButtonModule,
    MatFormFieldModule,
    MatSelectModule,
  ],
  templateUrl: './alterar-forma-pagamento-dialog.component.html',
  styleUrl: './alterar-forma-pagamento-dialog.component.css',
})
export class AlterarFormaPagamentoDialogComponent {
  public idFormaPagamento: number | null = null;

  get qtdSelecionados(): number {
    return this.data.quantidadeContas;
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: AlterarFormaPagamentoDialogData,
    public dialogRef: MatDialogRef<AlterarFormaPagamentoDialogComponent>
  ) {}

  public close(): void {
    this.dialogRef.close({ confirm: false } as AlterarFormaPagamentoDialogResult);
  }

  public confirm(): void {
    this.dialogRef.close({
      confirm: true,
      idFormaPagamento: this.idFormaPagamento,
    } as AlterarFormaPagamentoDialogResult);
  }
}
